// Autogenerated file
export const waybillTitleStatusesEnum = {
    ReceivedOrCreated: "ReceivedOrCreated",
    Accepted: "Accepted",
    Signed: "Signed",
    Sent: "Sent",
    Processed: "Processed",
    Declined: "Declined",
    Failed: "Failed",
    FailedToSend: "FailedToSend",
    InvalidSignature: "InvalidSignature",
};
export const waybillTitleStatuses = [
    { label: "Получен или создан", value: "ReceivedOrCreated" },
    { label: "Принят", value: "Accepted" },
    { label: "Подписан", value: "Signed" },
    { label: "Отправлен", value: "Sent" },
    { label: "Обработан", value: "Processed" },
    { label: "Отклонён", value: "Declined" },
    { label: "Ошибка", value: "Failed" },
    { label: "Ошибка отправки во внешнюю систему", value: "FailedToSend" },
    { label: "Невалидная подпись", value: "InvalidSignature" },
];
